import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetPaginator({
  isNextDisabled,
  isPrevDisabled,
  onNextClick,
  onPrevClick
}) {
  if (isNextDisabled && isPrevDisabled) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "center",
    children: [/*#__PURE__*/_jsxs(Button, {
      disabled: isPrevDisabled,
      onClick: onPrevClick,
      size: "default",
      use: "transparent",
      children: [/*#__PURE__*/_jsx(LeftIcon, {
        color: isPrevDisabled ? 'icon-interactive-disabled' : 'icon-interactive-default'
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.tabs.assets.paginator.prev"
      })]
    }), /*#__PURE__*/_jsxs(Button, {
      disabled: isNextDisabled,
      onClick: onNextClick,
      size: "default",
      use: "transparent",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.tabs.assets.paginator.next"
      }), /*#__PURE__*/_jsx(RightIcon, {
        color: isNextDisabled ? 'icon-interactive-disabled' : 'icon-interactive-default'
      })]
    })]
  });
}